import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api.js";
import { ErrorBox, VerdictPill, fmtDate } from "../components/helpers.jsx";

function FlagList({ flags }) {
    if (!flags || flags.length === 0) return <div className="text-dim">No flags fired.</div>;
    return (
        <div className="flag-list">
            {flags.map((f, i) => (
                <div key={i} className={`flag sev-${f.severity}`}>
                    <div className="cat">{f.category}</div>
                    <div className="reason">{f.reason}</div>
                </div>
            ))}
        </div>
    );
}

export default function AttemptDetail() {
    const { id } = useParams();
    const [row, setRow] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get(`/api/admin/attempts/${id}`)
            .then((d) => { if (alive) setRow(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [id]);

    let flags = null, telemetry = null;
    if (row?.flagsJson)     try { flags     = JSON.parse(row.flagsJson); }     catch { /* */ }
    if (row?.telemetryJson) try { telemetry = JSON.parse(row.telemetryJson); } catch { /* */ }

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Attempt #{id}</h1>
                    <div className="sub"><Link to="/attempts">← all attempts</Link></div>
                </div>
                {row && <VerdictPill verdict={row.verdict} />}
            </div>

            <ErrorBox>{err}</ErrorBox>

            {row && (
                <>
                    <div className="card">
                        <h2>Summary</h2>
                        <table className="data">
                            <tbody>
                                <tr><th>Subject</th><td className="mono">{row.subject}</td></tr>
                                <tr><th>HWID</th><td className="mono">{row.hwid ?? "—"}</td></tr>
                                <tr><th>IP</th><td className="mono">{row.ip ?? "—"}</td></tr>
                                <tr><th>Endpoint</th><td>{row.endpoint}</td></tr>
                                <tr><th>Category</th><td>{row.category ?? "—"}</td></tr>
                                <tr><th>Reason</th><td>{row.reason ?? "—"}</td></tr>
                                <tr><th>Windows build</th><td className="mono">{row.windowsBuild ?? "—"}</td></tr>
                                <tr><th>When</th><td>{fmtDate(row.createdAt)}</td></tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="card" style={{ marginTop: 12 }}>
                        <h2>Flags ({flags?.length ?? 0})</h2>
                        <FlagList flags={flags} />
                    </div>

                    {row.screenshotPath && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Screenshot</h2>
                            <div className="text-dim" style={{ marginBottom: 8 }}>
                                Captured at heartbeat time. Auto-deleted 48h after the attempt.
                            </div>
                            <a
                                href={`/api/admin/attempts/${id}/screenshot`}
                                target="_blank"
                                rel="noreferrer"
                                title="Open full-size in a new tab"
                            >
                                <img
                                    src={`/api/admin/attempts/${id}/screenshot`}
                                    alt={`Screenshot for attempt #${id}`}
                                    style={{ maxWidth: "100%", border: "1px solid var(--border)", borderRadius: 4 }}
                                />
                            </a>
                        </div>
                    )}

                    {telemetry && (
                        <div className="card" style={{ marginTop: 12 }}>
                            <h2>Telemetry snapshot</h2>
                            <pre className="json-block">{JSON.stringify(telemetry, null, 2)}</pre>
                        </div>
                    )}
                </>
            )}
        </>
    );
}
